import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, map } from 'rxjs';
import { environment } from '../environments/environment';

interface ObjectKeys {
  [key: string]: any
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config!: ObjectKeys;
  private env!: ObjectKeys;
  constructor(private _http: HttpClient) { }

  /**
  * Loads platform config from assets/config/{configEnv}.json.
  * configEnv comes from environment.ts and is replaced per build (development / staging / preprod / cloudrun / production).
  */
  load(): Observable<boolean> {
    const configEnv = environment.configEnv;
    return this._http.get<ObjectKeys>(`assets/config/${configEnv}.json`).pipe(
      tap(data => {
        this.config = data;
        this.env = { env: configEnv };
      }),
      map(() => true)
    );
  }

  /**
   * This function is used to get the current environment type
   * @param key its accept the environment key
   * @returns the environment type
   * @author chari on 05/26/2025
   */
  getEnv(key: any) {
    return this.env[key];
  }

  /**
   * this function is used to get the current environment data
   * @param key its accept the environment type
   * @returns environment data
   * @author chari 05/26/2025
   */
  get(key: any) {
    return this.config[key];
  }
}
